import { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import { H2, BodyText } from "src/atoms/typography";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";

const MAX_BAR_HEIGHT = 56;
const MIN_BAR_HEIGHT = 24;
const MAX_SCALE = MAX_BAR_HEIGHT / MIN_BAR_HEIGHT;

class EveryNoiseAnimation extends PureComponent {
  state = {
    scale: 1
  };

  componentDidMount() {
    const { noiseMeter } = this.props;
    noiseMeter.on("change", this.updateScale);
  }

  componentWillUnmount() {
    const { noiseMeter } = this.props;
    noiseMeter.off("change", this.updateScale);
  }

  updateScale = (volume) => {
    const { scale } = this.state;
    let newScale = Math.min(MAX_SCALE, 1 + volume);
    newScale = Math.round(newScale * 100) / 100;
    if (scale === newScale) return;
    this.setState({ scale: newScale });
  };

  render() {
    const { scale } = this.state;
    return (
      <Box
        p="53px"
        bg="primaryLight"
        borderRadius="100%"
        transform={`scale(${scale})`}
      />
    );
  }
}

class EveryNoiseView extends PureComponent {
  render() {
    const { t, noiseMeter, avatar } = this.props;

    return (
      <Flex alignItems="center" width="100%" pl="120px" pr="48px">
        <Box flex="0 0 auto" position="relative">
          <Box
            bg="transparent"
            transform="translate(-50%, -50%)"
            position="absolute"
            top="50%"
            left="50%"
          >
            <EveryNoiseAnimation noiseMeter={noiseMeter} />
          </Box>

          <CorrespondingAvatar avatar={avatar} width="72px" height="72px" />
        </Box>
        <Box pl="120px">
          <H2 mb="8px" color="highEmphasis">
            {t("parentStation.everyNoise.heading")}
          </H2>
          <BodyText color="mediumEmphasis">
            {t("parentStation.everyNoise.text")}
          </BodyText>
        </Box>
      </Flex>
    );
  }
}

export default withTranslation()(EveryNoiseView);
